export default __webpack_public_path__ + "static/media/unicons.f5dd903d.svg";